import React, { useEffect, useState } from "react";
import { FaApple, FaGooglePlay } from "react-icons/fa";
import { MdClose } from "react-icons/md";

import mobileAppImage from "../../../assets/mobile_app_image.png";
import "./mobile_app_popup.css";

const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=pk.landtrack.proptech.club";
const APP_STORE_URL = "https://apps.apple.com/app/id6787122754";

const MobileAppPopup = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const popupTimer = window.setTimeout(() => {
      setIsVisible(true);
    }, 650);

    return () => window.clearTimeout(popupTimer);
  }, []);

  useEffect(() => {
    if (!isVisible) {
      return undefined;
    }

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setIsVisible(false);
      }
    };

    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", handleEscape);

    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", handleEscape);
    };
  }, [isVisible]);

  if (!isVisible) {
    return null;
  }

  return (
    <div className="mobile_app_popup_overlay" role="presentation">
      <button
        className="mobile_app_popup_backdrop"
        type="button"
        onClick={() => setIsVisible(false)}
        aria-label="Close mobile app popup"
      />
      <div className="mobile_app_popup_content" role="dialog" aria-modal="true" aria-labelledby="mobile_app_popup_hdng">
        <button
          className="mobile_app_popup_close"
          type="button"
          onClick={() => setIsVisible(false)}
          aria-label="Close popup"
        >
          <MdClose aria-hidden="true" />
        </button>

        <div className="mobile_app_popup_image">
          <img src={mobileAppImage} alt="PropTech Club mobile app preview" />
        </div>

        <div className="mobile_app_popup_copy">
          <h2 id="mobile_app_popup_hdng">Carry The PropTech Ecosystem With You</h2>
          <p>
            Connect with members, follow events, and stay close to the real estate ecosystem from anywhere
          </p>
          <div className="mobile_app_popup_downloads">
            <a
              className="mobile_app_popup_download"
              href={PLAY_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaGooglePlay aria-hidden="true" />
              <span>Get it on <strong>Google Play</strong></span>
            </a>
            <a
              className="mobile_app_popup_download"
              href={APP_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaApple aria-hidden="true" />
              <span>Download on the <strong>App Store</strong></span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileAppPopup;
